import { useState, useEffect, useCallback } from 'react';
import { apiService, APIError } from '../services/api';

interface UseTaskCategoriesState {
  categories: string[];
  loading: boolean;
  error: APIError | null;
}

export const useTaskCategories = () => {
  const [state, setState] = useState<UseTaskCategoriesState>({
    categories: [],
    loading: false,
    error: null,
  });

  const loadCategories = useCallback(async () => {
    setState(prev => ({ ...prev, loading: true, error: null }));

    try {
      const response = await apiService.getTaskCategories();
      setState(prev => ({
        ...prev,
        categories: response.categories || [],
        loading: false,
      }));
    } catch (error) {
      const apiError =
        error instanceof APIError
          ? error
          : new APIError('Error al cargar categorías');

      setState(prev => ({
        ...prev,
        loading: false,
        error: apiError,
      }));
    }
  }, []);

  const refreshCategories = useCallback(() => {
    loadCategories();
  }, [loadCategories]);

  // Cargar datos iniciales
  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  return {
    ...state,
    loadCategories,
    refreshCategories,
  };
};
